import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import {EbayStockFilters} from "@app/core/interfaces/ebay";

@Injectable({
  providedIn: 'root'
})
export class EbpService extends ApiService {
  public getStocks(filters: EbayStockFilters = {}): Observable<any> {
      return this.http.get<any>(`${this.apiUrl}/ebp/stocks-erreurs`)
  }

  public getRefresh(): Observable<any> {
      return this.http.get<any>(`${this.apiUrl}/ebp/refresh`)
  }

  public postResendErrors(): Observable<any> {
      return this.http.post(`${this.apiUrl}/ebp/renvoi-erreur`, {})
  }
}
